export default "__VITE_ASSET__f5fcb35f__"